module.exports = __webpack_public_path__ + "img/produse.6c5d4bd6.svg";